/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {DeleteSendSafelyPackageRequest} from '@cash-web/protos/squareup/privacyvault/service.pb'
import {DeleteSendSafelyPackageResponse} from '@cash-web/protos/squareup/privacyvault/service.pb'


export const deleteSendSafelyPackage = (request: DeleteSendSafelyPackageRequest, options?: CashRequestOptions) => post<DeleteSendSafelyPackageRequest, DeleteSendSafelyPackageResponse>("/2.0/cash/delete-send-safely-package", request, {...options, rejectOnError: true })